import "core-js/modules/es6.array.for-each";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import ShorthandsNormalizerFactory, { SIDES, HORIZONTAL, VERTICAL } from "./ShorthandsNormalizerFactory";

var StyleNormalizer = function () {
  function StyleNormalizer() {
    _classCallCheck(this, StyleNormalizer);

    this.normalizers = {};
    this.createNormalizers('margin', [HORIZONTAL, VERTICAL, SIDES]);
    this.createNormalizers('padding', [HORIZONTAL, VERTICAL, SIDES]);
    this.createNormalizers('border', [SIDES], 'Width');
  }

  _createClass(StyleNormalizer, [{
    key: "createNormalizers",
    value: function createNormalizers(prop, shorthands) {
      var _this = this;

      var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      shorthands.forEach(function (shorthand) {
        var propName = prop + shorthand.type + suffix;

        if (_this.normalizerExists(propName)) {
          throw Error("Normalizer for '" + propName + "' shorthand already exists");
        }

        _this.normalizers[propName] = ShorthandsNormalizerFactory.createNormalizer(prop, shorthand, suffix);
      });
    }
  }, {
    key: "normalizerExists",
    value: function normalizerExists(normalizerName) {
      return !!this.normalizers[normalizerName];
    }
  }, {
    key: "canNormalize",
    value: function canNormalize(prop) {
      return this.normalizerExists(prop);
    }
  }, {
    key: "normalize",
    value: function normalize(prop, val) {
      return this.normalizers[prop](val);
    }
  }]);

  return StyleNormalizer;
}();

export { StyleNormalizer as default };